import {Injectable} from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
@Injectable()
export class Userservice {
    constructor(){}

    currentUser:any;
    token:string;
                public getToken(){
                    return this.token;
                }
    isAuthenticated(token):boolean{
        let jwtHelper:JwtHelper=new JwtHelper();
        this.token=token;
        return !jwtHelper.isTokenExpired(token);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/userservice.ts